import axios from 'axios'
import { getToken, getrefresh_Token,setToken, getExpires, setExpires,setrefresh_Token } from './auth'
import store from '@/store'
import { Message } from 'element-ui'

// 是否正在刷新的标志
let isRefreshing = false;
// 存储请求的数组
let cacheRequestArr = [];

// 将所有的请求都push到数组中，其实数组是[function(token){}, function(token){},...]
function cacheRequestArrHandle(cb) {
  cacheRequestArr.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去重新发起请求
function afreshRequest(newtoken) {
  cacheRequestArr.map((callback) => callback(newtoken));
  cacheRequestArr = [];
}

// 判断Token是否过期
function isTokenExpired() {
  let curTime = parseInt(new Date().getTime() / 3600000) ;  // 小时
  let expiresTime = curTime - Number(getExpires()) 
  // 还差10分钟即将过期或者已经过期了
  if( expiresTime >= 5 ) {
    return true
  }
  return false
}
// export const baseurl = 'http://127.1.1.1:5200/api/v1.0'
export const baseurl = 'https://honglandata.com:5100/api/v1.0'
// create an axios instance
const service=axios.create({
  baseURL: baseurl,
  withCredentials: true,
  // timeout: 60 * 1000     //请求超时
})

// reuqest 拦截
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = `Bearer ${ getToken() }`
      // 判断token是否即将过期，且不是请求刷新token的接口
      if ( isTokenExpired() && config.url !== '/login/refresh' ) {
        // 所有的请求来了，先判断是否正在刷新token,
        // 如果不是，将刷新token标志置为true并请求刷新token.
        // 如果是，则先将请求缓存到数组中
        // 等到刷新完token后再次请求之前缓存的请求接口即可
        if (!isRefreshing) {
          // 标志改为true,表示正在刷新
          isRefreshing = true
          axios({
            url: '/login/refresh',
            method: 'post',
            baseURL: baseurl ,
            withCredentials: true,
            timeout: 15 * 1000,
            headers: {'Authorization': `Bearer ${ getrefresh_Token() }`}
          }).then(response => {
            const res = response.data
            isRefreshing =false
            if (res.code == 20000) {
              setToken(res.data.access_token)
              let curTime = parseInt(new Date().getTime() / 3600000)
              setExpires(curTime)
              setrefresh_Token(res.data.refresh_token)
              store.commit('user/SET_TOKEN', res.data.access_token)
              
              // 刷新token之后重新请求之前的请求
              afreshRequest(getToken())
            } else {
              store.dispatch('user/resetToken').then(() => {
                // location.reload()
              })
            }
          }).catch(err => {
            store.dispatch('user/resetToken').then(() => {
              // location.reload()
            })
          }).finally(() => {
            isRefreshing = false
          })
          let retry = new Promise((resolve) => {
            cacheRequestArrHandle((token) => {
              config.headers['Authorization'] = `Bearer ${ token }`
              resolve(config)
            })
          })
          return retry
        } else { 
          let retry = new Promise((resolve) => {
            cacheRequestArrHandle( (token) => {
              config.headers['Authorization'] = `Bearer ${ token }`
              resolve(config)
            })
          })
          return retry
        }
      } else {
        return config
      }
    } else {
      config.headers['Content-Type']='application/json;charset=utf-8'
    }
    return config
  },
  error => {
    console.log('err - ',error)
    return Promise.reject(error)
  }
);

// response 拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.config.responseType === 'blob') {
      return res
    } else {
      if (res.code !== 20000) {
        if (res.code == 40011) {
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }
        return Promise.reject(new Error(response.message || 'Error'))
      } else {
        return res
      }
    }
  },
  error => {
    // console.log('err + ' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
) 
export default service





// WEBPACK FOOTER //
// ./src/utils/request.js